import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CvdsUtilsService {
	/**
	 * return a mpped array base just on the metadata information
	 * @param context Photos Data
	 * @param fields type of map depend on the tap photo review
	 */
	mapFields(context: any, fields: any[] | undefined): Array<any> {
		if (!context || !fields) {
			return [];
		}

		const data = [];
		fields.forEach(field => {
			const newField = this.map(context, field);
			if (newField) {
				data.push(newField);
			}
		});

		return data;
	}

	/**
	 * return a mpped array base just on the metadata information
	 * @param context Photos Data
	 * @param fields type of map depend on the tap photo review
	 */
	map(context: any, field: any): Array<any> {
		try {
			const { fieldName, label } = field;
			if (fieldName &&  Object.prototype.hasOwnProperty.call(context, fieldName)) {
				return {
					...context[fieldName],
					label: label || ''
				};
			}
		} catch (e) {
			console.warn(e);
		}

		return null;
	}

	/**
	 * return a mpped array base just on the metadata information
	 * @param context Photos Data
	 * @param fields type of map depend on the tap photo review
	 */
	mapArrayFields(context: any[] | undefined, fields: any[] | undefined): Array<any> {
		if (!context || !fields) {
			return [];
		}

		const data = [];
		context.forEach(item => {
			const newItem = this.mapFields(item, fields);
			if (newItem.length) {
				data.push(newItem);
			}
		});

		return data;
	}
}
